// Our team's Amigo log (D8). Wording from the Amigo design's copy sheet (Amigo log, Amigo log couldn't do, Amigo log no
// results, Row status); FoodAmigos only, so always Amigo, never the assistant.
export default {
  title: 'Amigo-loki',
  intro:
    'Jokainen Amigon käsittelemä pyyntö: mitä pyydettiin, missä, kuka pyysi ja kuka hyväksyi. Vain FoodAmigos näkee tämän sivun.',
  // The tab list's name for screen readers.
  tabs_label: 'Amigo-loki',
  tabs: {
    requests: 'Pyynnöt',
    gaps: 'Ei onnistunut',
  },
  filters: {
    restaurant: 'Ravintola',
    all_restaurants: 'Kaikki ravintolat',
    brand: '{{name}} · Brändi',
    restaurant_unknown: 'Ravintola {{id}}',
    searching: 'Etsitään ravintoloita…',
    no_restaurant: 'Ravintolaa nimeltä ”{{query}}” ei löytynyt',
    period: 'Ajanjakso',
    start_date: 'Alkupäivä',
    end_date: 'Loppupäivä',
    refresh: 'Päivitä',
    gap: 'Pyydetty: {{request}}',
    change_set: 'Yhden muutoksen taustalla oleva pyyntö',
    remove: 'Poista suodatin: {{label}}',
    clear: 'Tyhjennä suodattimet',
  },
  columns: {
    steps: 'Vaiheet',
    when: 'Milloin',
    request: 'Pyyntö',
    restaurant: 'Ravintola',
    asked_by: 'Pyytäjä',
    result: 'Tulos',
  },
  show_steps: 'Näytä vaiheet: {{request}}',
  approved_by: 'Hyväksynyt {{name}}',
  nothing_approved: 'Ei hyväksyttyä',
  results: {
    applied: '{{applied}} otettu käyttöön',
    applied_skipped: '{{applied}} otettu käyttöön · {{skipped}} ohitettu',
    partial: '{{applied}}/{{total}} otettu käyttöön',
    imported: 'Tuotu',
    importing: 'Tuodaan',
    waiting: 'Odottaa hyväksyntää',
    rejected: 'Hylätty',
    undone: 'Kumottu',
    partly_undone: '{{undone}}/{{total}} kumottu',
    expired: 'Vanhentunut',
    replaced: 'Korvattu',
    failed: 'Epäonnistui',
    answered: 'Vastattu',
    not_yet: 'Ei vielä onnistu',
    off_limits: 'Kielletty',
    not_allowed: 'Ei sallittu',
    switched_off: 'Poistettu käytöstä',
    guard: 'Turvatarkistus pysäytti',
    not_found: 'Ei löytynyt',
  },
  steps: {
    asked: '{{name}} pyysi',
    asked_anonymous: 'Pyydetty',
    approved: 'Hyväksynyt {{name}}',
    approved_alone: 'Hyväksytty',
    applied_one: 'Otettu käyttöön {{count}} muutos',
    applied_other: 'Otettu käyttöön {{count}} muutosta',
    failed_one: '{{count}} ei otettu käyttöön',
    failed_other: '{{count}} ei otettu käyttöön',
    rejected: 'Hylätty',
    undone: 'Kumottu',
    undone_by: 'Kumottu, hyväksyjä {{name}}',
    skipped_one: '{{count}} ohitettu',
    skipped_other: '{{count}} ohitettu',
    skipped_state: 'Ohitettu',
    more_one: 'ja {{count}} muuta',
    more_other: 'ja {{count}} muuta',
    changes_one: '{{count}} muutos',
    changes_other: '{{count}} muutosta',
    other: 'Tarkistaa jotain',
  },
  // The line over a request's steps (QA49): how many, how many shop refused, how many failed.
  summary: {
    steps_one: '{{count}} vaihe',
    steps_other: '{{count}} vaihetta',
    refused_one: '{{count}} hylätty',
    refused_other: '{{count}} hylätty',
    failed_one: '{{count}} epäonnistui',
    failed_other: '{{count}} epäonnistui',
  },
  // A request that changed nothing says what came of it, under Result (design: Log · steps open).
  outcomes: {
    title: 'Tulos',
    answered: 'Vastaus: mitään ei muutettu.',
    waiting: 'Odottaa hyväksyntää. Mitään ei ole vielä muutettu.',
    rejected: 'Hylätty: mitään ei muutettu.',
    expired: 'Vanhentui ilman hyväksyntää: mitään ei muutettu.',
    replaced: 'Korvattu uudemmalla kortilla: tähän ei muutettu mitään.',
    undone: 'Kumottu: muutokset peruttiin.',
    partly_undone: 'Osittain kumottu: {{undone}}/{{total}} muutosta peruttiin.',
    failed: 'Epäonnistui: mitään ei muutettu.',
    not_yet: 'Ei vielä onnistunut: mitään ei muutettu. Lasketaan kohtaan Ei onnistunut.',
    off_limits: 'Rajojen ulkopuolella: mitään ei muutettu.',
    not_allowed: 'Ei sallittu tämän henkilön roolille: mitään ei muutettu.',
    switched_off: 'Poistettu käytöstä täällä: mitään ei muutettu.',
    guard: 'Turvatarkistus pysäytti: mitään ei muutettu.',
    not_found: 'Ei löytynyt: mitään ei muutettu.',
    importing: 'Tuodaan. Jokainen ruokalaji menee kohtaan Menu → Muokkaushistoria.',
    imported: 'Tuotu. Jokainen ruokalaji on kohdassa Menu → Muokkaushistoria.',
  },
  changes: {
    // With where they were made: "3 changes · Hilltop Burger · Ehrenfeld".
    where: '{{changes}} · {{where}}',
    title_one: '{{count}} muutos',
    title_other: '{{count}} muutosta',
    show_all: 'Näytä kaikki {{count}} muutosta',
    show_fewer: 'Näytä vähemmän',
    from: 'mistä',
    to: 'mihin',
    removed: 'Poistettu',
  },
  row_states: {
    skipped: 'Ohitettu',
    failed: 'Ei otettu käyttöön',
    stale: 'Muuttunut sillä välin',
    kept: 'Jätetty ennalleen',
  },
  menu_history: 'Avaa Menu → Muokkaushistoria',
  // Opens the request's chat in the Amigo panel, on its restaurant (read only when someone else started it).
  open_chat: 'Avaa keskustelu',
  // Both links first switch the dashboard to the request's restaurant; this says that didn't work.
  switch_failed: 'Ravintolan avaaminen epäonnistui. Yritä uudelleen.',
  pagination: {
    label: 'Sivut',
    summary: '{{from}}–{{to}} / {{total}} pyyntöä',
    previous: 'Edellinen sivu',
    next: 'Seuraava sivu',
  },
  empty: {
    title: 'Ei pyyntöjä ravintolalle {{restaurant}} tällä ajanjaksolla',
    text: 'Amigo ei ole käsitellyt siellä mitään välillä {{from}}–{{to}}.',
    title_any_day: 'Ei vielä pyyntöjä ravintolalle {{restaurant}}',
    text_any_day: 'Amigo ei ole vielä käsitellyt siellä mitään.',
    title_everywhere: 'Ei pyyntöjä tällä ajanjaksolla',
    text_everywhere: 'Amigo ei ole käsitellyt mitään välillä {{from}}–{{to}}.',
    title_nothing: 'Ei vielä pyyntöjä',
    text_nothing: 'Amigo ei ole vielä käsitellyt mitään.',
  },
  loading: 'Ladataan…',
  error: {
    title: 'Lokia ei voitu ladata',
    text: 'Yritä hetken kuluttua uudelleen.',
    retry: 'Yritä uudelleen',
  },
  gaps: {
    intro:
      'Mitä Amigo ei vielä osannut tehdä, ryhmiteltynä pyynnön mukaan, useimmin pyydetyt ensin. Kielletyt pyynnöt ja pyynnöt, joita rooli ei salli, eivät näy tässä.',
    columns: {
      area: 'Alue',
      request: 'Mitä ihmiset pyysivät',
      count: 'Pyydetty',
      last_at: 'Viimeksi pyydetty',
      requests: 'Pyynnöt',
    },
    count: '{{count}}×',
    see_requests_one: 'Näytä {{count}} pyyntö',
    see_requests_other: 'Näytä {{count}} pyyntöä',
    today: 'Tänään klo {{time}}',
    yesterday: 'Eilen klo {{time}}',
    empty_title: 'Pyyntöjä, joita Amigo ei pystynyt hoitamaan, ei ole',
    empty_text: 'Amigo pystyi hoitamaan kaiken, mitä siltä pyydettiin.',
  },
  areas: {
    menu: 'Ruokalista',
    hours: 'Aukioloajat',
    order_settings: 'Tilausasetukset',
    my_info: 'Omat tiedot',
    marketing: 'Markkinointi',
    gift_cards: 'Lahjakortit',
    reports: 'Raportit',
    website: 'Verkkosivusto',
    integrations: 'Integraatiot',
    delivery: 'Toimitus',
    payments: 'Maksut',
    team: 'Tiimi',
    billing: 'Laskutus',
    settings: 'Asetukset',
    other: 'Muut',
  },
};
